module.exports = __webpack_public_path__ + "static/media/order-icon.96e79cc4.svg";